module.exports = __webpack_public_path__ + "static/img/noimg.c024e77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/noimg.jpg
// module id = NVaA
// module chunks = 1